export function calcTimeSpeedByScore(score: number) {
  // score=0 -> 1.0배
  // score=100 -> 1 + sqrt(100) / 20 = 1.5배
  // score=900 -> 1 + sqrt(900) / 20 = 1 + 30 / 20 = 2.5배
  // score=1600 -> 1 + sqrt(1600) / 20 = 1 + 40 / 20 = 3.0배
  const speed = 1 + Math.sqrt(Math.max(0, score)) / 20;

  // 상한(예: 최대 3배)
  return Math.min(3, speed);
}
